import axios from "axios";
export default {
  namespaced: true,
  state: {
    cash_advances: [],
  },
  getters: {
    cash_advances(state) {
      return state.cash_advances;
    },
  },
  mutations: {
    SET_CASH_ADVANCES(state, cash_advances) {
      state.cash_advances = cash_advances;
    },
    ADD_CASH_ADVANCE(state, cash_advance) {
      state.cash_advances.unshift(cash_advance);
    },
    EDIT_CASH_ADVANCE(state, cash_advance) {
      var index = state.cash_advances.findIndex((a) => a.id == cash_advance.id);
      state.cash_advances.splice(index, 1, cash_advance);
    },
    DELETE_CASH_ADVANCE(state, cash_advance) {
      let filtered = state.cash_advances.filter((c) => {
        return c.id != cash_advance.id;
      });
      state.cash_advances = filtered;
    },
  },
  actions: {
    // get cash_advances
    async get_cash_advances({ commit }, branch_id) {
      let response = await axios.get("/cash_advances", {
        params: branch_id ? { branch_id } : {},
      });
      commit("SET_CASH_ADVANCES", response.data);
    },
    async add_cash_advance({ commit }, request) {
      let response = await axios.post("/cash_advance", request);
      commit("ADD_CASH_ADVANCE", response.data);
    },
    async edit_cash_advance({ commit }, request) {
      let response = await axios.put("/cash_advance", request);
      commit("EDIT_CASH_ADVANCE", response.data);
    },
    async delete_cash_advance({ commit }, request) {
      await axios.delete("/cash_advance/" + request.id);
      commit("DELETE_CASH_ADVANCE", request);
    },
    async cancel_cash_advance(_context, id) {
      let response = await axios.post(`/cash_advance/${id}/cancel`);
      return response.data;
    },
    async get_employee_pending_cas(_context, employee_id) {
      let response = await axios.get(
        `/cash_advances/employee/${employee_id}/pending`
      );
      return response.data;
    },
    async pay_cash_advance_manually(_context, payload) {
      let response = await axios.post("/cash_advances/pay_manually", payload);
      return response.data;
    },
    async get_pay_ca_history() {
      let response = await axios.get("/cash_advances/payment_history");
      return response.data;
    },
    async get_outstanding_balances() {
      let response = await axios.get("/cash_advances/outstanding_balances");
      return response.data;
    },
  },
};
